export default "__VITE_ASSET__CTjDxUHC__"